import React, { useEffect } from "react";
import { useGlobal } from "reactn";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { UserState } from "@ugg/shared/api/requests/accounts/user-state";

import SettingsNotification from "./SettingsNotification";
import MyAccount from "./routes/MyAccount/MyAccount";
import FilterPreferences from "./routes/FilterPreferences/FilterPreferences";
import Plus from "./routes/Premium/Plus";
import Boost from "./routes/Premium/Boost";
import CancelBoostSubscription from "./routes/BoostPremium/CancelBoostSubscription";

interface SettingsRouterProps {
  setPage: (page: string) => void;
  userSettings: Record<string, unknown>;
  userState: UserState;
  refetchQueries: Array<{ query: unknown }>;
  setRedirectingProvider: (provider: string | null) => void;
  premiumState?: UserState["premium"];
}

const SettingsRouter: React.FC<SettingsRouterProps> = (props) => {
  const location = useLocation();
  const [settingsNotification, setSettingsNotification] = useGlobal("settingsNotification");
  const { setPage, userSettings, userState, refetchQueries, setRedirectingProvider, premiumState } = props;
  const isBoost = premiumState?.hasLegacyBoost;

  const settingsProps = {
    setPage,
    userSettings,
    userState,
    refetchQueries,
    setSettingsNotification,
    setRedirectingProvider,
    premiumState,
  };

  useEffect(() => {
    setSettingsNotification(false);
  }, [location.pathname]);

  return (
    <div className="settings-router">
      {settingsNotification && <SettingsNotification {...settingsProps} />}
      <Switch>
        <Route path={AppRoutes.SETTINGS_ACCOUNT} render={() => <MyAccount {...settingsProps} />} />
        <Route path={AppRoutes.SETTINGS_FILTER_PREFERENCES} render={() => <FilterPreferences {...settingsProps} />} />
        <Route path={AppRoutes.SETTINGS_PLUS} exact render={() => <Plus {...settingsProps} />} />
        {isBoost && (
          <Route path={AppRoutes.SETTINGS_BOOST_CANCEL_PLAN} render={() => <CancelBoostSubscription {...settingsProps} />} />
        )}
        {isBoost && <Route path={AppRoutes.SETTINGS_BOOST} exact render={() => <Boost {...settingsProps} />} />}
        <Redirect from={AppRoutes.SETTINGS_PLUS + "/*"} to={AppRoutes.SETTINGS_PLUS} />
        <Redirect to={AppRoutes.SETTINGS_ACCOUNT} />
      </Switch>
    </div>
  );
};

export default SettingsRouter;
